/**
 * @description - Provides a window open function to handle opening links with target blank and ref='noopener'
 */
export default function windowOpenBlank(link: string) {
  return window.open(link, '_blank')
}
